export default __webpack_public_path__ + "static/media/mainLogo.6e6daa74.png";